import { defineMessages, IntlShape } from "react-intl";

import BoundaryLegendClassificationType from "@mapmycustomers/shared/enum/boundaryLegends/BoundaryLegendClassificationType";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<BoundaryLegendClassificationType>({
  [BoundaryLegendClassificationType.EQUAL_INTERVAL]: {
    id: "boundaryClassificationType.equalInterval",
    defaultMessage: "Equal Interval",
  },
  [BoundaryLegendClassificationType.MANUAL]: {
    id: "boundaryClassificationType.manual",
    defaultMessage: "Manual",
  },
  [BoundaryLegendClassificationType.NATURAL_BREAKS]: {
    id: "boundaryClassificationType.naturalBreaks",
    defaultMessage: "Natural Breaks",
  },
  [BoundaryLegendClassificationType.QUANTILE]: {
    id: "boundaryClassificationType.quantile",
    defaultMessage: "Quantile",
  },
  [BoundaryLegendClassificationType.SIMPLE]: {
    id: "boundaryClassificationType.simple",
    defaultMessage: "Simple",
  },
});

const getBoundaryClassificationTypeDisplayName = (
  intl: IntlShape,
  classificationType: BoundaryLegendClassificationType
) => getDisplayName(intl, messages, classificationType, "BoundaryLegendClassificationType");

export default getBoundaryClassificationTypeDisplayName;
